<div class="configure-system-locations">
    <div class="alert alert-info">Define the locations of the system to be used</div>
    <div class="mb-3 row">
        <div class="col-12 col-md-6 d-flex flex-column mb-4">
            <h3>Roles</h3>
            @for (roleLocation of roleLocations; track roleLocation) {
                <div class="d-flex flex-row justify-content-between align-items-center">
                    <adapt-link-role [role]="roleLocation.role"></adapt-link-role>
                    @if (hasGlobalEdit) {
                        <button adaptButton="deleteBorderless"
                                adaptTooltip="Delete role link"
                                (click)="deleteRoleLocation(roleLocation)"></button>
                    }
                </div>
            }
            @if (!hasGlobalEdit && roleLocations.length === 0) {
                There are no roles assigned to this system.
            }
            @if (hasGlobalEdit) {
                <adapt-select-role [required]="false"
                                   [filter]="roleFilter"
                                   [(role)]="selectedRole"
                                   (roleChange)="onRoleSelected($event)"></adapt-select-role>
            }
        </div>
        <div class="col-12 col-md-6 d-flex flex-column mb-4">
            <h3>Groups</h3>
            @for (teamLocation of teamLocations; track teamLocation.systemLocationId) {
                <div class="d-flex flex-row justify-content-between align-items-center mb-1">
                    <adapt-link-team [team]="teamLocation.team"
                                     [showIcon]="true"
                                     [smallIcon]="true"></adapt-link-team>
                    @if (this.configurableTeams.includes(teamLocation.team!)) {
                        <button adaptButton="deleteBorderless"
                                adaptTooltip="Delete group link"
                                (click)="deleteTeamLocation(teamLocation)"></button>
                    }
                </div>
            }
            @if (!hasGlobalEdit && teamLocations.length === 0) {
                There are no groups assigned to this system.
            }
            @if (this.configurableTeams.length > 0) {
                <adapt-select-team [required]="false"
                                   [filter]="teamFilter"
                                   [(team)]="selectedTeam"
                                   [grouped]="true"
                                   (teamChange)="onTeamSelected($event)"></adapt-select-team>
            }
        </div>
    </div>
    <div class="mb-3 row">
        <div class="col-12 col-md-6 d-flex flex-column mb-4">
            <h3>Zones</h3>
            @for (zoneLocation of zoneLocations; track zoneLocation) {
                <div class="d-flex flex-row justify-content-between align-items-center mb-1">
                    <adapt-zone-label [zone]="zoneLocation.zone"></adapt-zone-label>
                    @if (hasGlobalEdit) {
                        <button adaptButton="deleteBorderless"
                                adaptTooltip="Delete zone link"
                                (click)="deleteZoneLocation(zoneLocation)"></button>
                    }
                </div>
            }
            @if (!hasGlobalEdit && zoneLocations.length === 0) {
                There are no zones assigned to this system.
            }
            @if (hasGlobalEdit) {
                <adapt-select-zone [filter]="zoneFilter"
                                   [(zone)]="selectedZone"
                                   (zoneChange)="onZoneSelected($event)"></adapt-select-zone>
            }
        </div>
    </div>
</div>
